var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockSmallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.879,
    height: 9.879,
    viewBox: "0 0 9.879 9.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clockSmallIcon",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3327",
    "data-name": "Path 3327",
    d: "M4.84,952.4a4.84,4.84,0,1,0,4.84,4.84A4.845,4.845,0,0,0,4.84,952.4Zm0,.523A4.316,4.316,0,1,1,.523,957.24,4.321,4.321,0,0,1,4.84,952.923Zm0,.916a.262.262,0,0,0-.262.262v3.139a.253.253,0,0,0,.131.222c.824.484,1.661.955,2.5,1.439a.258.258,0,0,0,.262-.445L5.1,957.083V954.1A.262.262,0,0,0,4.84,953.839Z",
    transform: "translate(0 -952.4)",
    fill: "var(--mainColor)",
    stroke: "var(--mainColor)",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSmallIcon);
export default __webpack_public_path__ + "static/media/clockSmallIcon.2c6e4a45e799e11a0cf651006c4fc9bb.svg";
export { ForwardRef as ReactComponent };